import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class FeaturedTitle extends React.PureComponent<FeaturedTitle.Props, FeaturedTitle.State> {
    public static sectionId = 'title';

    public buildItem(block: FeaturedTitle.Block, i: number) {
      return (
        <div className={'w-full md:w-1/3'} key={i}>
          <div className={'relative'}>

            {block.settings.linkurl ? 
              <a
                onClick={() => trackPromotionClick(
                  [{
                    id: `${this.props.section.id}-block-${i}`,
                    name: block.settings.title,
                    creative: 'Featured titles',
                    position: `${i}`
                  }],
                  block.settings.linkurl
                )}
                className={'absolute inset-0 z-10'}
              /> : null
            }
            <Snippets.Image
              alt={block.settings.title || 'Featured title image'}
              className={'bg-cover bg-center absolute inset-0 h-full md:max-h-32 max-h-24'} 
              ratio={'4:3'} 
              src={block.settings.image} 
            />

            <div className={`absolute inset-0 p-4 flex flex-col items-center justify-center text-center ${block.settings.colour == 'light' ? 'text-white' : 'text-black'}`}>
              <div>
                <Snippets.Heading 
                  tag={'h2'}
                  size={'h1'}
                  className={'leading-none mb-1-6'}
                >
                  {block.settings.title}
                </Snippets.Heading>
                {block.settings.linktext ? (
                  <p className={'text-xs uppercase font-bold tracking-wide'}>{block.settings.linktext}</p>
                ) : null}
              </div>
            </div>
            
          </div>
        </div>
      )
    }

    public render(): JSX.Element {
      console.log()
      const { settings, blocks } = this.props.section
      if (!settings) {
        return <React.Fragment/>
      }

      return (
        <section className={`dynamic-image-content ${settings && settings.verticalspacing ? 'sm:mb-6-4 mb-1-6' : '' }`}>
          <div className={`${!settings.fullwidth && 'max-w-8xl'} mx-auto`}>
            <div className={'border flex flex-wrap'}>
              {blocks ? (
                blocks.map((block: any, i: number) => this.buildItem(block, i))
              ) : (
                []
              )}
            </div>
          </div>
        </section>
      )
    }
}

export namespace FeaturedTitle {
    export type Options = ShopifyNext.Section<{
    fullwidth: boolean;
    verticalspacing: boolean;
    }>;
    export type Block = {
    settings: {
        title: string;
        image: string;
        linktext: string;
        linkurl: string;
        colour: string;
    }
    }
    export type Blocks = Block[]
    export interface Props extends GlobalProps {
    section: FeaturedTitle.Options;
    blocks: FeaturedTitle.Blocks;
    }
    export interface State {}
}
